/*
 * Project: BookingEngine
 * Module: PaymentLoading.js
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';

import '../../../static/images/loading5.gif';

const PaymentLoading = (props: {}, context: {t: () => {}}) => (
  <div className="PaymentLoading">
    <img src="/img/loading5.gif"/>
    <h1>{context.t('Loading booking...')}</h1>
  </div>
);

PaymentLoading.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default PaymentLoading;
